import gql from "graphql-tag";

import {gqlOp, type GqlOperation} from "@khan/data-gql-core";

import type {updateSubscriptionFromTokenType} from "./__graphql-types__/index.ts";

const UPDATE_SUBSCRIPTION_BY_TOKEN_MUTATION: GqlOperation<
    updateSubscriptionFromTokenType["response"],
    updateSubscriptionFromTokenType["variables"]
> = gqlOp(gql`
    mutation updateSubscriptionFromToken(
        $token: String!
        $subscribe: Boolean!
    ) {
        updateSubscriptionByToken(token: $token, subscribe: $subscribe) {
            error {
                code
                debugMessage
            }
        }
    }
`);

export default UPDATE_SUBSCRIPTION_BY_TOKEN_MUTATION;
